import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { ArrowRight, Lock } from "lucide-react";
import { useAuth } from "@/lib/AuthContext";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("admin@sodimate-uae.com");
  const [password, setPassword] = useState("admin123");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      toast.success("Welcome back");
      nav("/dashboard");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-white">
      {/* Left — branding (desktop only) */}
      <div className="relative hidden lg:flex flex-col justify-between p-12 border-r border-gray-200 industrial-stripes">
        <div>
          <div className="label-eyebrow">Sodimate · since 1976</div>
          <div className="mt-4 font-display text-5xl xl:text-6xl font-bold tracking-tight leading-[0.95]">
            Bulk handling.<br />
            <span className="text-[#004B87]">Reimagined for the Gulf.</span>
          </div>
          <p className="mt-6 text-gray-600 max-w-md leading-relaxed">
            Internal sales platform to develop Sodimate's business in the UAE —
            cement, ready-mix, water treatment, waste-to-energy, desalination.
          </p>
        </div>

        <div className="grid grid-cols-3 gap-6 max-w-lg">
          <div className="border-l-2 border-[#004B87] pl-4">
            <div className="font-display text-3xl font-bold">40+</div>
            <div className="label-eyebrow">Years</div>
          </div>
          <div className="border-l-2 border-[#004B87] pl-4">
            <div className="font-display text-3xl font-bold">3500+</div>
            <div className="label-eyebrow">Installations</div>
          </div>
          <div className="border-l-2 border-[#004B87] pl-4">
            <div className="font-display text-3xl font-bold">60+</div>
            <div className="label-eyebrow">Countries</div>
          </div>
        </div>
      </div>

      {/* Right — form */}
      <div className="flex items-center justify-center p-8">
        <form
          onSubmit={submit}
          data-testid="login-form"
          className="w-full max-w-md section-card p-8"
        >
          <div className="flex items-center gap-2 mb-6">
            <Lock size={14} className="text-[#004B87]" />
            <span className="label-eyebrow">Secure Access</span>
          </div>
          <h1 className="font-display text-3xl font-bold tracking-tight mb-2">
            Sign in
          </h1>
          <p className="text-sm text-gray-500 mb-8">
            Sodimate UAE Business Development Console
          </p>

          <div className="space-y-4">
            <div>
              <label className="label-eyebrow block mb-2">Email</label>
              <input
                type="email"
                className="input-stark"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid="login-email-input"
                required
              />
            </div>
            <div>
              <label className="label-eyebrow block mb-2">Password</label>
              <input
                type="password"
                className="input-stark"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                data-testid="login-password-input"
                required
              />
            </div>
          </div>

          <button
            type="submit"
            disabled={busy}
            data-testid="login-submit-button"
            className="btn-primary w-full justify-center mt-6"
          >
            {busy ? "Signing in..." : "Sign in"} <ArrowRight size={16} />
          </button>

          <div className="mt-8 pt-6 border-t border-gray-200">
            <div className="label-eyebrow mb-3">Demo accounts</div>
            <div className="space-y-1 text-[12px] text-gray-600 font-mono">
              <div>admin@sodimate-uae.com / admin123</div>
              <div>manager@sodimate-uae.com / manager123</div>
              <div>sales@sodimate-uae.com / sales123</div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}
